import { get, writable, type Writable } from 'svelte/store';
import { applyStylesToElement } from './chart';

export const INTERACTION_CLASS = 'DVIZ_INTERACTION';

export type Interaction = {
  classname: string;
  onReset: { [key: string]: string };
  onSelect: { [key: string]: string };
  onTrigger: { [key: string]: string };
};

export const barInteraction: Interaction = {
  classname: 'bar-chip-foobar',
  onReset: {
    opacity: '1'
  },
  onTrigger: {
    opacity: '.2'
  },
  onSelect: {
    opacity: '1'
  }
};

export const labelInteraction: Interaction = {
  classname: 'label-text',
  onReset: {
    fill: 'var(--color)',
    opacity: 'var(--opacity)'
  },
  onTrigger: {
    fill: 'transparent',
    opacity: '0'
  },
  onSelect: {
    fill: 'var(--selectedColor)',
    opacity: '1'
  }
};

export const labelBackgroundInteraction: Interaction = {
  classname: 'label-background',
  onReset: {
    fill: 'var(--backgroundColor)',
    stroke: 'transparent'
  },
  onTrigger: {
    fill: 'transparent',
    stroke: 'transparent'
  },
  onSelect: {
    fill: 'var(--selectedBackgroundColor)',
    opacity: '1'
  }
};

export type InteractionState = {
  selected: string[];
};

export interface InteractionStore extends Writable<InteractionState> {
  triggerInteraction: (interaction: Interaction[], selectedIds: string[]) => void;
  resetInteraction: (interaction: Interaction[]) => void;
}

export const interactionStore = (chartId: string): InteractionStore => {
  const store = writable<InteractionState>({ selected: [] });
  const { set, subscribe, update } = store;

  return {
    set,
    subscribe,
    update,
    triggerInteraction: (interactions, selectedIds) => {
      const state = get(store);

      state.selected = selectedIds || [];
      set(state);

      updateInteraction(chartId, interactions, selectedIds);
    },
    resetInteraction: (interactions) => {
      const state = get(store);

      state.selected = [];
      set(state);

      updateInteraction(chartId, interactions);
    }
  };
};

export const updateInteraction = (
  id: string,
  interactions: Interaction[],
  selectedIds?: string[]
) => {
  if (!id || typeof document === 'undefined') return;

  interactions.forEach((interaction) => {
    // Query all of the interactive elements in the chart
    const interactionElements: NodeListOf<HTMLElement> = document.querySelectorAll(
      `#${id} .${INTERACTION_CLASS}.${interaction.classname}`
    );

    interactionElements.forEach((element) => {
      if (selectedIds) {
        const isSelected = selectedIds.some((classname) => element.classList.contains(classname));

        element.style.transition = 'all 0.2s ease-in';

        if (isSelected) {
          applyStylesToElement(element, interaction.onSelect);
        } else {
          applyStylesToElement(element, interaction.onTrigger);
        }
      } else {
        applyStylesToElement(element, interaction.onReset);
      }
    });
  });
};
